import { ModuloValutazioneRisposta } from ".";
export class RispostaElementoModulo {
  domandaId?: string;
  risposta?: ModuloValutazioneRisposta;
}
